













































import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { BookingListModule } from '@/store/modules/bookingList';
import { AgencyModule } from '@/store/modules/agency';
import Alert from '@/components/Shared/Alert.vue'
import BookingDto from '@/models/Bookings/BookingDto'
import PageNames from '@/router/PageNames';
import GiganautVue from '@/components/Shared/GiganautVue';
import BookingCreate from '@/components/Bookings/BookingCreate.vue';
import BookingStatus from '@/components/Bookings/Display/BookingStatus.vue';
import BookingListSearchCriteria from '@/components/Bookings/BookingListSearchCriteria.vue';


@Component({
	name: 'AgencyBookings',
  	components: { Alert, BookingCreate, BookingStatus, BookingListSearchCriteria }
})
export default class extends GiganautVue {

  async navigateToBooking(bookingId: string) {
    this.$router.push({ name: PageNames.AgencyBookingDetails, params: { bookingid: bookingId } });
  }

  get loading() {
		return BookingListModule.loading;
   }
   
  private search = '';

  get bookings() {
    return BookingListModule.bookings;
  }

   private headers = [
    { text: 'Ref', value: 'sequenceNumber' },
    { text: 'Branch', value: 'branch.brandName' },
    { text: AppModule.currentAgencyContext.labels.company, value: 'company.brandName'},
    { text: AppModule.currentAgencyContext.labels.location, value: 'location.brandName'},
    { text: 'Start Date', value: 'startAt'},
    { text: 'End Date', value: 'endAt'},
    { text: 'Status', value: 'status'},
    { text: 'Actions' },
  ]
}
